import { DefaultService } from '@/services/DefaultService';

export default class AcertosService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }
    
    find(uuid) {
        //a fazer
    }

    exportarAcerto(idconfjasper, acerto) {
        //despesa/acerto/{id}/exportar.json
        let headCopy = { ...this._headers};
        headCopy.responseType = 'arraybuffer';
        return this._http.post(`${this._env}/despesa/acerto/${idconfjasper}/exportar`, acerto, headCopy)
            .then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
    }

    deleteAcertoById(id) {
        //recebe idacerto
        return this._http.delete(`${this._env}/despesa/acerto/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    finalizar(acerto) {
        return this._http.post(`${this._env}/despesa/acerto`, acerto, this._headers,).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(filtros, column, order, page = 0, limit = 20, ...params) {
        return this._http.post(encodeURI(`${this._env}/despesa/acertos.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), filtros, this._headers)
            .then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
    }

}